import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap"; // FIX 1: Import Col
import { useSelector } from "react-redux"; // FIX 2: Import useSelector to get userType

const Cta = () => {
    // FIX 3: Define userType (getting it from Redux or setting a default)
    // Adjust the state path ('auth' or 'user') based on your actual Redux store structure
    const { userType } = useSelector((state) => state.auth || { userType: 'candidate' });

    return (
        <React.Fragment>
            <section className="section bg-light border-top border-bottom p-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={9}> {/* Now 'Col' is defined */}
                            <div className="section-title text-center" data-aos="zoom-in">
                                {userType === 'employer' ? (
                                    <>
                                        <h3 className="title mb-3 pb-2 fw-bold">
                                            Hire Exceptional <span className="text-primary">Hospitality Talent</span>
                                        </h3>
                                        <p className="para-desc text-muted mx-auto" style={{ maxWidth: '750px' }}>
                                            Streamline your recruitment for hotels, restaurants, and luxury resorts. 
                                            Webvi Hospitality connects you with pre-screened professionals—from executive chefs to front-desk managers.
                                        </p>
                                        <div className="mt-4 pt-2">
                                            <Link to="/post-job" className="btn btn-primary btn-hover lg-btn px-4 py-2 me-2">
                                                <i className="uil uil-plus-circle me-1"></i> Post a Job
                                            </Link>
                                            <Link to="/contact" className="btn btn-outline-primary btn-hover lg-btn px-4 py-2">
                                                Hire Talent
                                            </Link>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <h3 className="title mb-3 pb-2 fw-bold">
                                            Elevate Your <span className="text-primary">Hospitality Career</span>
                                        </h3>
                                        <p className="para-desc text-muted mx-auto" style={{ maxWidth: '750px' }}>
                                            Join Webvi Hospitality to discover premium opportunities in the world’s leading hotels. 
                                            We match your passion for service with the right career move.
                                        </p>
                                        <div className="mt-4 pt-2">
                                            <Link to="/signin" className="btn btn-primary btn-hover lg-btn px-4 py-2 me-2">
                                                <i className="uil uil-search me-1"></i> Browse Jobs
                                            </Link>
                                            <Link to="/signin" className="btn btn-outline-primary btn-hover lg-btn px-4 py-2">
                                                Upload Resume
                                            </Link>
                                        </div>
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>

                <style>{`
                    .lg-btn {
                        font-weight: 600;
                        letter-spacing: 0.5px;
                        border-radius: 8px;
                        transition: all 0.3s ease;
                    }
                    .btn-primary {
                        background-color: #387ed8;
                        border-color: #387ed8;
                    }
                    .btn-hover:hover {
                        transform: translateY(-2px);
                        box-shadow: 0 5px 15px rgba(56, 126, 216, 0.3);
                    }
                `}</style>
            </section>
        </React.Fragment>
    );
};

export default Cta;